import { z } from "zod";
import apiRepresentation2dSchema from "./apiRepresentation2dSchema";

const apiSvgRepresentation2dSchema = apiRepresentation2dSchema.extend({
    width: z.number().nullable(),
    height: z.number().nullable()
  });

export default apiSvgRepresentation2dSchema;